import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material';
import {ApprovalPending} from '../../shared/dto/approval-pending';
import {FormControl, FormGroup} from '@angular/forms';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {MatTableDataSource} from '@angular/material/table';
import {ReversedSuspendService} from '../../shared/service/reversed-suspend.service';
import {ApprovalModel} from '../../shared/dto/approval.model';

@Component({
  selector: 'app-reversed-suspend-verification-request-viewer',
  templateUrl: './reversed-suspend-verification.component.html',
  styleUrls: ['./reversed-suspend-verification.component.scss']
})
export class ReversedSuspendVerification implements OnInit {

  public userName: string;
  public type: string;
  blacklistForm: FormGroup;
  public approvalPendingList: ApprovalPending[];
  approvalModel: ApprovalModel = new ApprovalModel();
  approvalPending: ApprovalPending = new ApprovalPending();
  displayedColumns: string[] = ['refNo', 'nic', 'name', 'cdc' ,'stage', 'createdDate', 'action'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private route: ActivatedRoute, private suspendReverseService: ReversedSuspendService,
              private tokenStorageService: TokenStorageService) {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
    });
    this.userName=this.tokenStorageService.getUserObjectToken().username;
  }

  ngOnInit() {
    this.blacklistForm = new FormGroup({
      appRefNo: new FormControl(null),
      name: new FormControl(null),
      nic: new FormControl(null),
      cdcNo: new FormControl(null),
    });

    this.getPendingVerificationList();
  }

  setBase64(code: string): string {
    return btoa(code);
  }

  getPendingVerificationList() {
    this.approvalModel.type = this.type;
    this.suspendReverseService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.approvalPendingList = data;
        this.dataSource = new MatTableDataSource(this.approvalPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    )
  }

  onSearch() {
    this.approvalPending.appRefNo = this.blacklistForm.value.appRefNo;
    this.approvalPending.cdcNo = this.blacklistForm.value.cdcNo;
    this.approvalPending.name = this.blacklistForm.value.name;
    this.approvalPending.nic = this.blacklistForm.value.nic;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = this.type;

    this.suspendReverseService.searchPendingRequestData(this.approvalPending).subscribe(
      (result: any ) => {
        this.approvalPendingList = result;
        this.dataSource = new MatTableDataSource(this.approvalPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onReset() {
    this.blacklistForm.reset({
      sidNo: null,
      name: null,
      nicNo: null,
      cdcNo: null,
    });
    this.getPendingVerificationList();
  }

}
